export function LogoMark() {
  return (
    <svg viewBox="0 0 100 100" aria-hidden="true"><polygon points="4,6 30,6 50,78 70,6 96,6 61,100 39,100" fill="#D0202E" /><polygon points="50,78 61,100 39,100" fill="#96101C" /></svg>
  );
}
